import React, { useState } from 'react'
import * as PhosphorIcons from '@phosphor-icons/react'
import { toast } from '../utils'
const ProjectAgentsSettings = ({
  project,
  project_path,
  agents,
  all_agents,
}) => {
  const [selectedAgents, setSelectedAgents] = useState(agents.map(agent => agent.name))
  
  const toggleAgent = (agentId) => {
    setSelectedAgents(prev =>
      prev.includes(agentId)
        ? prev.filter(id => id !== agentId)
        : [...prev, agentId],
    )
  }

  const updateProjectAgents = async () => {
    const response = await fetch(project_path, {
      method: 'PUT',
      body: JSON.stringify({ project: { agent_ids: selectedAgents } }),
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })
    if (response.ok) {
      const data = await response.json()
      setSelectedAgents(data.agents.map(agent => agent.name))
      toast({message: 'Project agents updated successfully', type: 'success', duration: 3000, gravity: 'top', position: 'right', close: true})
    } else {
      toast({message: 'Failed to update project agents', type: 'error', duration: 3000, gravity: 'top', position: 'right', close: true})
    }
  }

  return (
    <div className="card bg-base-100 shadow-xl p-6">
      <div className="flex flex-col gap-4">
        <div className="card p-6">
          <p className="text-lg text-center mb-4">Available Agents</p>
          <div className="flex flex-col gap-4">
            {all_agents.map((agent) => (
              <div
                className="flex flex-col p-4 rounded-lg border-2 border-base-300 hover:bg-base-200 transition-colors shadow-sm"
                key={agent.id}>
                <div className="flex items-center gap-4">
                  <div className="flex items-center gap-4 flex-1">
                    <div className={`p-3 rounded-lg ${agent.bg_class}`}>
                      {PhosphorIcons[agent.icon] ?
                        React.createElement(PhosphorIcons[agent.icon], {
                          size: 24,
                          className: agent.color_class,
                        })
                        :
                        <PhosphorIcons.Tag size={24}
                                            className={agent.color_class}/>
                      }
                    </div>

                    <div className="flex flex-col gap-0.5">
                      <div className="flex items-center gap-2">
                        <span
                          className="text-lg font-semibold">{agent.label}</span>
                        <span
                          className="text-sm font-medium text-base-content/70">{agent.short_label}</span>
                      </div>
                      <span
                        className="text-sm font-medium text-base-content/70">{agent.agent_type}</span>
                      <span
                        className="text-sm text-base-content/60">{agent.description}</span>
                    </div>
                  </div>

                  <label title={agent.tooltip}>
                    <input type="checkbox"
                            checked={selectedAgents.includes(agent.id)}
                            onChange={() => toggleAgent(agent.id)}
                            className="checkbox checkbox-lg border-2 checkbox-primary"
                    />
                  </label>
                </div>
              </div>
            ))}
          </div>
            <button 
            onClick={updateProjectAgents}
            className="btn btn-outline btn-primary mt-4">
              <PhosphorIcons.PencilLine className="w-5 h-5" weight="fill"/>
              Update {project.name}
            </button>
        </div>
      </div>
    </div>
  )
}

export default ProjectAgentsSettings